import axios from "axios";
import { getToken } from "./userService";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://backend-dot-immersely-ai.nw.r.appspot.com/api/v1";

export const CREDITS_PER_DOLLAR = 10;

/**
 * Convert Immersely credits to cash earned (10 credits = $1)
 * @param {number} credits
 */
export async function convertCredits(credits) {
  const response = await axios.post(
    `${API_BASE_URL}/credits/convert`,
    { credits },
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getToken()}`,
      },
    }
  );
  return response.data;
}

/**
 * Get credit ledger history
 */
export async function getCreditLedger({ limit = 20, offset = 0 } = {}) {
  const response = await axios.get(`${API_BASE_URL}/credits/ledger`, {
    params: { limit, offset },
    headers: {
      "Authorization": `Bearer ${getToken()}`,
    },
  });
  return response.data;
}

/**
 * Get conversion rate from API (falls back to local constant)
 */
export async function getCreditConversionRate() {
  try {
    const response = await axios.get(`${API_BASE_URL}/credits/rate`, {
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    return {
      creditsPerDollar: CREDITS_PER_DOLLAR,
      description: `${CREDITS_PER_DOLLAR} credits = $1.00`,
    };
  }
}

export async function getCreditPackages() {
  const response = await axios.get(`${API_BASE_URL}/credits/packages`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
}

export async function createCreditTopup(packageId) {
  const response = await axios.post(
    `${API_BASE_URL}/credits/topup`,
    { packageId },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return response.data;
}

export async function confirmCreditTopup(sessionId) {
  const response = await axios.post(
    `${API_BASE_URL}/credits/topup/confirm`,
    { sessionId },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return response.data;
}
